<template>
  <div id="app">
    <main ref="main" v-if="carregamentoPagina" class="fonte-secundaria">
      <transition :name="transitionName" mode="out-in">
        <router-view @mostrar-header="carregamentoHeader = true" />
      </transition>
    </main>
    <HeaderSideBar :urlSair="urlSair" v-if="carregamentoHeader" />
    <footer class="cor-fonte" v-if="$route.name === 'Home'">
      <span class="negrito"> Versão: </span>
      {{ $store.getters.getVersaoProjeto }}
    </footer>
    <ComponentesGlobais />
    <unicom-modal-loading v-model="loading" />
  </div>
</template>

<script>
import AppMixin from "./AppMixin";
import ComponentesGlobais from "@/views/ComponentesGlobais/ComponentesGlobais";
import HeaderSideBar from "@/views/HeaderSideBar/HeaderSideBar";

export default {
  mixins: [AppMixin],
  components: {
    ComponentesGlobais,
    HeaderSideBar
  },
  data() {
    return {
      transitionName: ""
    };
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";

      if (to.name === "Home") {
        this.transitionName = "slide-right";
      }
    }
  }
};
</script>

<style lang="scss">
@import "./App";
</style>
